import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export const FaqSection = () => {
  const faqs = [{
    q: '¿Para qué grados sirve?',
    a: 'El material fue pensado para nivel primario y contiene propuestas adaptables desde 1.º hasta 7.º grado. Podés seleccionar las actividades según la edad, el nivel de complejidad y las características de tu grupo.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Después de completar la compra, recibís el acceso digital por email. Desde allí podés descargar los archivos PDF, guardarlos e imprimir las actividades que necesites.'
  }, {
    q: '¿Es un producto físico o digital?',
    a: 'Es un producto digital. No se envía por correo postal. Lo recibís en formato PDF para descargar e imprimir.'
  }, {
    q: '¿Incluye contenidos curriculares?',
    a: 'Sí. El fútbol y el Mundial funcionan como hilo conductor. El objetivo es trabajar contenidos curriculares de Lengua, Matemática, Geografía, Ciencias Naturales, Educación Física, estadística, probabilidad, convivencia y valores.'
  }, {
    q: '¿Puedo elegir solamente algunas actividades?',
    a: 'Sí. Podés utilizar la secuencia completa o seleccionar las propuestas que mejor se adapten a tu planificación, grado y cantidad de clases disponibles.'
  }, {
    q: '¿Los cuatro bonos están incluidos?',
    a: 'Sí. Durante la oferta actual recibís el Tablón de Estadísticas Interactivo, el Kit Aula Mundialista, la Guía de Recreo Dinámico y la Ceremonia de Campeones sin costo adicional.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí. Contás con la Garantía Gol de Victoria de 7 días. Si revisás el material y no es lo que esperabas, podés solicitar la devolución dentro de ese plazo.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="bg-familia-section py-10 md:py-16 px-4 md:px-6 border-y border-white/5" data-id="element-67">
      <div className="max-w-3xl mx-auto w-[92%] md:w-full" data-id="element-68">
        <h2 className="text-[20px] sm:text-2xl md:text-3xl font-display font-extrabold text-center mb-8 md:mb-10 text-white" data-id="element-69">
          ❓ PREGUNTAS FRECUENTES
        </h2>
        <div className="space-y-2 md:space-y-3" data-id="element-70">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`border rounded-xl overflow-hidden transition-all duration-300 ${isOpen ? 'border-familia-electric bg-familia-card' : 'border-white/10 bg-familia-bg'}`} data-id="element-71">
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full px-4 md:px-5 py-3 md:py-4 text-left flex justify-between items-center gap-3" data-id="element-72">
                  <span className="font-bold text-[13px] sm:text-[15px] text-white" data-id="element-73">
                    {faq.q}
                  </span>
                  <span className={`text-familia-electric text-xl transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-45' : ''}`} data-id="element-74">
                    +
                  </span>
                </button>
                <AnimatePresence data-id="element-75">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-76">
                      <div className="px-4 md:px-5 pb-4 md:pb-5 pt-1 text-familia-gray text-[13px] sm:text-[14px] leading-relaxed border-t border-white/5 font-medium" data-id="element-77">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
};